import funcoesGerais from "../app/funcoes/funcoesGerais";
import { ConsultaBoleto } from "../app/interfaces/consultaBoleto";
import { Boleto, NovoBoleto } from "../app/interfaces/sicoob/boleto";
import { BoletoBaixa } from "../app/interfaces/sicoob/boletoBaixa";
import { MensagemInstrucao } from "../app/interfaces/sicoob/mensagemInstrucao";

export const configuracoes: any = {
  url_token: 'https://auth.sicoob.com.br/auth/realms/cooperado/protocol/openid-connect/token',
  url_cobranca_bancaria: 'https://api.sicoob.com.br/cobranca-bancaria/v2',
  clienteId: '6eca9c94-bf58-4f17-9296-e2fd23e1da4e',
  numeroContaCorrente: 703850016,
  cooperativa: '4149',
  numeroContrato: 339156,
}

export function gerarInstrucoes(dataVencimento: any): string[] {

  return [
    `A partir ${funcoesGerais.tratarData(dataVencimento)} Juros de 0,03%/dia.`,
    `A partir ${funcoesGerais.tratarData(dataVencimento)} multa de 5,00%.`,
    "Não conceder desconto."
  ]
}

// interface fixoBoleto {
//   numeroContrato: number,
//   modalidade: number,
//   numeroContaCorrente: number,
//   especieDocumento: string,
//   identificacaoEmissaoBoleto: number,
//   identificacaoDistribuicaoBoleto: number,
//   tipoDesconto: number,
//   tipoMulta: number,
//   dataMulta: number,
// }

function randomNumber(): number {
  return Math.floor(100000000000000000 + Math.random() * 900000000000000000);
}

export function gerarMapBoleto(valorTotal: number, dataVencimento: Date, dadosCliente: any): NovoBoleto {
  return {
    // numeroContrato: configuracoes.numeroContrato,
    // modalidade: 1, //1 - SIMPLES COM REGISTRO
    // numeroContaCorrente: configuracoes.numeroContaCorrente,
    // especieDocumento: 'DM',
    seuNumero: randomNumber().toString(), //número gerado localmente
    // identificacaoEmissaoBoleto: 1, //Código de identificação de emissão do boleto. Informar os valores listados abaixo. - 1 Banco Emite - 2 Cliente Emite
    // identificacaoDistribuicaoBoleto: 1, //Código de identificação de distribuição do boleto. Informar os valores listados abaixo. - 1 Banco Distribui - 2 Cliente Distribui
    valor: Number(valorTotal.toFixed(2)),
    dataVencimento: funcoesGerais.gerarDataVencimento(dataVencimento),
    valorMulta: Number((valorTotal * 0.05).toFixed(2)),
    // dataLimitePagamento: funcoesGerais.gerarDataVencimento(funcoesGerais.adicionarDiasDataVencimento(new Date(), 20)), Removido para obter a data máxima do banco
    // tipoDesconto: 0, //0 Sem Desconto
    // tipoMulta: 1, //1 Valor fixo, 2 Percentual -- Manter valor fixo para evitar erro de juros acima de 99 reais.
    dataMulta: funcoesGerais.gerarDataVencimentoJurosMora(dataVencimento, true),
    // Data de vencimento alterada contando a partir do dia da geração do boleto - REMOVIDO new Date(dataVencimento)
    // dataEmissao: funcoesGerais.gerarDataEmissao(new Date()),
    // tipoJurosMora: 1, //1 Valor Fixo
    dataJurosMora: funcoesGerais.gerarDataVencimentoJurosMora(dataVencimento, true),
    valorJurosMora: 1,
    numeroParcela: 1, //1
    pagador: {
      numeroCpfCnpj: (dadosCliente.Tipo === 'pessoaJuridica' ? dadosCliente.CNPJ : dadosCliente.CPF).replace(/[^\w\s]/gi, ''),
      nome: dadosCliente.Nome,
      endereco: `${dadosCliente.Logradouro}, ${dadosCliente.Numero}`,
      bairro: dadosCliente.Bairro,
      cidade: dadosCliente.Cidade,
      cep: dadosCliente.CEP.replace(/[^\w\s]/gi, ''),
      uf: dadosCliente.UF
    },
    mensagensInstrucao: gerarInstrucoes(dataVencimento),
    gerarPdf: true,
  }
}

export function gerarMapBoletoBaixa(boleto: ConsultaBoleto): BoletoBaixa[] {
  return [
    {
      numeroContrato: configuracoes.numeroContrato,
      modalidade: 1, //1 - SIMPLES COM REGISTRO
      nossoNumero: boleto.NossoNumero,
      seuNumero: boleto.SeuNumero
    }
  ]
}
